import { render, staticRenderFns } from "./TickerAdminViewMutualFund.vue?vue&type=template&id=15281082&scoped=true"
import script from "./TickerAdminViewMutualFund.vue?vue&type=script&lang=js"
export * from "./TickerAdminViewMutualFund.vue?vue&type=script&lang=js"
import style0 from "./TickerAdminViewMutualFund.vue?vue&type=style&index=0&id=15281082&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15281082",
  null
  
)

export default component.exports